//select vehicle script
window.solution = window.solution || {};
solution.SidebarFilters = (function() {
  var selectors = {
    element: '#sidebar-form',
    submitBtn: '#sidebar-form-submit',
    errorSelector: '#error-message',
    apiKey1: 'AIzaSyCrvvcQ3PrXtVwYn19u925eg3cya_iVPu4', //Google API Key
    sheetKey1: '11Ke8hDwhPVWRv-imMp-xIUYKK5mw8VVJM7FOWEWwLfo', //Google sheet key
    sheetKey: '1LL5CcXr3iKtHF5uTHzwj-e6J4zaZ9zgrVvnEeziqtLA', //Google API Key
    apiKey: 'AIzaSyBUkukj9VAd6IHVnqKOof5KUwabzFL3AIA' //Google sheet key
  };
  if(!$(selectors.element).length) {
    return;
  }
  function _handleSubmitBtn(data) {
    
    $(selectors.submitBtn).on(
      'click',
      function(evt) {
    	evt.preventDefault();
        var selectedValues = [];
        $('select[name=filter]').each(function() {
		  var self = $(this);
          if(self.val()) {
          	selectedValues.push(self.val());
          } else {
            self.addClass('select--error');
          }
        })
        /*
		 * If all select box has values
         *   - Match the selected options with the main data
         *   - Redirect to the matched collection
        */
        
        if(selectedValues.length === 3) {
          var matchedArray = data.find(
            arr => arr[0] === selectedValues[0] &&
            arr[1] === selectedValues[1] &&
            arr[2] === selectedValues[2]
          );
          var collectionUrl = matchedArray[3];
          if(collectionUrl) {
          	location.href = collectionUrl;
          }
        }
      }
    )
  }
  function _fillOtherDropdowns(index, value, data) {
    var currentIndex = parseInt(index);
    var nextOptions = [];
    if(currentIndex >= 5) {
      return;
    }
    /*
     * If the option matches get related options
     * 	- Create an unique array of answers
     *	- Create the next step html
    */
    for(var d=0; d<data.length; d++) {
      if(data[d][currentIndex - 1] == value) {
        nextOptions.push(data[d][currentIndex]);
      }
    }
    var uniqueDropdownArray = nextOptions.filter(function(q, i) {
      return nextOptions.indexOf(q) == i;
    });
    var nextSelectBox = $('[name=filter][data-index="' + (currentIndex+1) + '"]');
    if(nextSelectBox.length) {
      for(var f=0; f<uniqueDropdownArray.length; f++) {
        if(uniqueDropdownArray[f] && uniqueDropdownArray[f] != '') {
          var optionExists = (nextSelectBox.find('option[value="' + uniqueDropdownArray[f] + '"]')).length > 0;
          if(!optionExists) {
            nextSelectBox.append($('<option>', {
              value: uniqueDropdownArray[f],
              text : uniqueDropdownArray[f]
            }));
          }
        }
      }
    }
  }
  function _fillFirstDropdown(data) {
    debugger;
  	var dropdownArray = [];
    var allData = [];
    /*
     * Get the first level answers
     * Along with all data for next steps
    */
    for(var i=1; i<data.length; i++){
      if(!data[i] || !data[i].length) {
        continue;
      }
      else if(data[i]) {
        dropdownArray.push(data[i][0]);
        allData.push(data[i]);
      }
    }
    /*
     * Create first dropdown on page load
    */
    var uniqueDropdownArray = dropdownArray.filter(function(q, i) {
      return dropdownArray.indexOf(q) == i;
    });
    for(var f=0; f<uniqueDropdownArray.length; f++) {
      if(uniqueDropdownArray[f] != '') {
        $('[name=filter][data-index="1"]').append($('<option>', {
          value: uniqueDropdownArray[f],
          text : uniqueDropdownArray[f]
        }));
      }
    }
    /*
     * Take necessary actions when option choosed
    */
     $(document).on('change', 'select[name=filter]',
      function(evt) {
        var value = $(this).val();
        var index = $(this).attr('data-index');
        _fillOtherDropdowns(index, value, allData);
      }
    ); 
  }
  function _getSheetData() {
    $.ajax({
      url: 'https://sheets.googleapis.com/v4/spreadsheets/' + selectors.sheetKey + '/values/Sheet1?key=' + selectors.apiKey,
      dataType: 'json',
      success: function(data){
        _fillFirstDropdown(data.values);
        _handleSubmitBtn(data.values);
      }
    });
  }
function _getSheetData3() {
  //url: 'https://sheets.googleapis.com/v4/spreadsheets/' + selectors.sheetKey + '/values/All?key=' + selectors.apiKey,
  const url = 'https://drive.google.com/file/d/1CvhczSHLoJoqhTX_8RvVRLG8OkTZRKZA/view';
  const url2 = 'https://sheets.googleapis.com/v4/spreadsheets/' + selectors.sheetKey + '/values/All?key=' + selectors.apiKey;

// Fetch the JSON file from the URL
fetch(url)
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(jsonData => {
        // Now 'jsonData' contains the parsed JSON from the URL
        console.log(jsonData);
       _fillFirstDropdown(jsonData.values);
        _handleSubmitBtn(jsonData.values);
    })
    .catch(error => {
        console.error('Error fetching the file:', error);
    });
}
  
  function _initEventListeners() {
    $('select[name=filter]').on(
      'click',
      function(evt) {
    	evt.preventDefault();
        var self = $(this);
        if(self.hasClass('select--error')) {
		  self.removeClass('select--error');
        }
      }
    )
  }
  return {
    init: function() {
      _getSheetData();
      _initEventListeners();
    }
  }
})();
$(document).ready(function() {

  solution.SidebarFilters.init();
});

//reset the values of sub category on change of the main category

$('[name=filter][data-index="2"]').on('change', function() {
  $('[name=filter][data-index="3"]').find('option').remove();
  $('[name=filter][data-index="3"]').append($('<option>', {
        value: "",
        text : "Model",
        disabled: "",
        selected: ""
      }));
  });

//reset the make and modal
$('[name=filter][data-index="1"]').on('change', function() {
  $('[name=filter][data-index="2"]').find('option').remove();
  $('[name=filter][data-index="2"]').append($('<option>', {
        value: "",
        text : "Make",
        disabled: "",
        selected: ""
      }));
  $('[name=filter][data-index="3"]').find('option').remove();
  $('[name=filter][data-index="3"]').append($('<option>', {
        value: "",
        text : "Model",
        disabled: "",
        selected: ""
      }));
  });

  //background change on change of the radio
  $('input[name="vehicle-type"]').change(function() {
      $('.select-vehicle').removeClass("selected");
      $(this).closest(".select-vehicle").addClass("selected");
  });

  //selecting the first option in mobile on page load
  $(document).on('click', 'input[name="vehicle-type"]',function(evt) {
      var selectedId = $(this).attr('id');
   
      if(selectedId == 'bike') {
        
        $('[id="form-id-1"]').find('option').removeAttr('selected');  
        $('#form-id-1 option').eq(2).prop('selected', true).change();  
     }
      if(selectedId == 'car') {
         $('[id="form-id-1"]').find('option').removeAttr('selected');
         $('#form-id-1 option').eq(1).prop('selected', true).change();
      }
    });



  $(window).on("load", function () {
      if(window.innerWidth < 990) {
        $('#car').click(); 
    }
  });      

  //reset the options on click of reset button
  $(document).on('click', '#reset-vehicle', function(evt) {

    if(window.innerWidth > 990) {
      $('#form-id-1 option').eq(0).prop('selected', true).change();

      $('[name=filter][data-index="2"]').find('option').remove();
      $('[name=filter][data-index="2"]').append($('<option>', {
            value: "",
            text : "Make",
            disabled: "",
            selected: ""
          }));
      $('[name=filter][data-index="3"]').find('option').remove();
      $('[name=filter][data-index="3"]').append($('<option>', {
            value: "",
            text : "Model",
            disabled: "",
            selected: ""
          }));
      }
      else {
        $('#car').click(); 
      }
  });

